import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios' // 引入axios
import EchartsView1 from '@/components/EchartsView1'
import EchartsView2 from '@/components/EchartsView2'
import EchartsView3 from '@/components/EchartsView3'
import EchartsView4 from '@/components/EchartsView4'
import MapDetail from '@/components/MapDetail'
import History from '@/components/EchartsView3-1'
import Home from '@/components/Home'
import ApiMap from '@/components/Map'
import Login from '@/components/Login'

Vue.prototype.$ajax = axios // 修改原型链
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/total',
      name: 'EchartsView1',
      component: EchartsView1
    },
    {
      path: '/today',
      name: 'EchartsView2',
      component: EchartsView2
    },
    {
      path: '/info',
      name: 'EchartsView3',
      component: EchartsView3
    },
    {
      path: '/data',
      name: 'EchartsView4',
      component: EchartsView4
    },
    {
      path: '/map',
      name: 'MapDetail',
      component: MapDetail
    },
    {
      path: '/history',
      name: 'History',
      component: History
    },
    {
      path: '/api/map',
      name: 'ApiMap',
      component: ApiMap
    }
  ]
})
// 请求拦截
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    next()
  } else {
    let token = sessionStorage.getItem('token')
    token ? next() : next('/login')
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js